import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import classNames from 'classnames';
const classButtonInactive = 'btn btn-default close-modal btn-block';
import * as actions from '../../../actions/response';
import {converter} from '../../../helpers/converter';
import { GetRegion } from '../../../constants';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import * as metricsActions from '../../../action-creators/metrics';
import Utils from "../../../utils/Utils";

class ModalSuccessDefault extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.isUpsell = false;

    props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  closeModal() {
    const { group_id} = this.props.queryParams;
    const redirect = () => {
      if (group_id) {
        return window.location.replace(ClaroUrlBuilder.card(GetRegion(), group_id));
      } else if(this.isUpsell){
        let pathFox = "";
        if(this.props.nav && this.props.nav.length > 0)
          pathFox = Utils.getPathFox(this.props.nav);
        return window.location = `/${GetRegion()}/${pathFox}`;
      }else {
          return window.location.replace(ClaroUrlBuilder.home());
      }
    };
    redirect();
  }

  onAccept(e, cb) {
    e.preventDefault();
    if (!cb) return this.closeModal();
    const scope = this;
    return cb(scope);
  }

    UNSAFE_componentWillMount() {
       if(this.props.modes){
           this.props.modes.map((item) => {
               if(item.producttype === "FOX" && item.buyLink.indexOf("services/payway/upsell") !== -1){
                   this.isUpsell = true;
               }
           })
       }
        if(this.props.buyLink){
          if(this.props.buyLink.indexOf("services/payway/upsell") !== -1){
              this.isUpsell = true;
          }
        }
    }

    jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
    }

  render() {
    const msg = converter.convertApaUnicode(this.props.translations, `${this.props.message}`, 'Felicidades!').replace("{@EMAIL}",this.props.email);
    const customIconClass = (this.props.iconClass) ? this.props.iconClass : false;

    const classes = {
      fa: true,
      'text-center': true,
      'fa-3x': true,
      'fa-check': !customIconClass,
    };

    if (customIconClass)
      classes[customIconClass] = customIconClass;

    const classesForBody = classNames(classes);

    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>x</Button>
          <h4 className="text-center">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className='modal-body text-center success'>
            <i className={classesForBody}></i>
            {this.isUpsell ? <p className='padding-top-2' dangerouslySetInnerHTML={
                {__html: msg}}></p>
            :  <p className='padding-top-2' dangerouslySetInnerHTML={
                    {__html: msg }
                }></p>
            }
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-4 col-md-4 col-sm-5 col-xs-12 padding-top-05">
              <Button
                className={ classButtonInactive }
                onClick={ (e) => this.onAccept(e, this.props.onAccept)}>
                {this.jsUcfirst(converter.convertApaUnicode(this.props.translations, "ip_telmex_success_button", "Comenzar a disfrutar"))}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    router: state.routing,
    email: state.user.username,
    nav: state.nav.nodeList,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
    setMetricsEvent(options) {
    dispatch(metricsActions.setMetricsEvent(options));
  }

});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSuccessDefault);
